import { zodResolver } from '@hookform/resolvers/zod';
import { Grid, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import {
  EditableLegalClientSchema,
  IEditableLegalClient,
} from '../../../../../../../Interfaces/IEditLegalClient';
import {
  getEmptyLegalClient,
  ILegalClient,
} from '../../../../../../../Interfaces/ILegalClient';
import { ILegalTransactionRelationship } from '../../../../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { getEmptyChildMember } from '../../../../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberChild';
import { IFamilyRelationship } from '../../../../../../../Interfaces/ILegalTransactionRelationship/Relationships/Family/ILegalTransactionFamilyRelationship';
import { getEmptyNaturalPerson } from '../../../../../../../Interfaces/INaturalPerson';
import { EditLegalClient } from '../../../../../../LegalClient/EditLegalClient';
import { useLegalClientStore } from '../../../../generic/legalClientStore';
import { NavRow } from '../../../../generic/NavRow';
import { updateOrCreateRelationship } from '../../../../generic/utilities';
import { isFamilyRelationship } from '../../../../Inherit/utilities';

type CreateChildSlideProps = {
  relationshipId: number;
  relationshipArray: ILegalTransactionRelationship[];
  setRelationshipArray: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationship[]>
  >;

  handleClose: () => void;
  handleNext: () => void;
  handleBack: () => void;
};

export function CreateChildSlide({
  relationshipId,
  relationshipArray,
  setRelationshipArray,
  handleNext,
  handleBack,
}: CreateChildSlideProps) {
  const [putLegalClient] = useLegalClientStore(state => [state.putLegalClient]);

  const legalClientMethods = useForm<IEditableLegalClient>({
    mode: 'onChange',
    defaultValues: {
      ...getEmptyLegalClient(),
      ...getEmptyNaturalPerson(),
      idLegalClient: 1,
    },
    resolver: zodResolver(EditableLegalClientSchema),
  });

  async function onSubmit() {
    const legalClientValid = await legalClientMethods.trigger();

    if (!legalClientValid) {
      // TODO: proper error handling
      console.log('Legal client data is not valid');
      console.log(legalClientMethods.formState.errors);
      console.log(legalClientMethods.getValues());
      return;
    }

    const baseRelationship = relationshipArray
      .filter(isFamilyRelationship)
      .find(rel => rel.idRelationship === relationshipId);

    if (!baseRelationship) {
      // TODO: proper error handling
      // This should not happen as the base parent should exist
      console.error('Base relationship not found for id:', baseRelationship);
      return;
    }

    const newLegalClient = legalClientMethods.getValues() as ILegalClient;

    const updatedLegalClient = putLegalClient(newLegalClient);

    const updatedFamilyRelationship: IFamilyRelationship = {
      ...baseRelationship,
      Members: [
        ...baseRelationship.Members,
        getEmptyChildMember(
          updatedLegalClient,
          baseRelationship.idRelationship
        ),
      ],
    };

    setRelationshipArray(
      updateOrCreateRelationship(relationshipArray, updatedFamilyRelationship)
    );

    handleNext();
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant='h4' sx={{ mb: 2 }}>
          Kind hinzufügen
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormProvider {...legalClientMethods}>
          <form id='testator-legal-client-form' noValidate>
            <EditLegalClient disableCompanyLegalClient />
          </form>
        </FormProvider>
      </Grid>

      <Grid item xs={12}>
        <NavRow
          nextButtonText='Speichern'
          handleNext={onSubmit}
          handleBack={handleBack}
        />
      </Grid>
    </Grid>
  );
}
